<template>
  <div class="ps-detail-head">
    <div class="ps-detail-head__main">
      <h2 class="ps-detail-head__title">
        {{ title }}
        <StatusBadge
          v-if="text"
          class="ps-detail-head__status"
          :status="status"
          :text="text"
          :show-icon="false"
        />
        <span v-if="version" class="ps-detail-head__version">{{ version }}</span>
      </h2>
      <div class="ps-detail-head__row">
        <div class="ps-detail-head__meta">
          <div
            v-for="m in metaList"
            :key="m.label"
            class="ps-detail-head__meta-item"
          >
            <img
              v-if="m.icon && iconMap[m.icon]"
              class="ps-detail-head__meta-icon"
              :class="'ps-detail-head__meta-icon--' + m.icon"
              :src="iconMap[m.icon]"
              alt=""
            />
            <span
              >{{ m.label }}：<b :class="{ warn: m.warn }">{{
                m.value
              }}</b></span
            >
          </div>
        </div>
        <div class="ps-detail-head__actions">
          <button
            v-if="showUpdate"
            type="button"
            class="ps-btn ps-btn--update"
            @click="$emit('update')"
          >
            <img :src="icons.edit" alt="" />
            <span>发起更新</span>
          </button>
          <button type="button" class="ps-btn ps-btn--back" @click="$emit('back')">
            <img :src="icons.back" alt="" />
            <span>返回总览</span>
          </button>
          <slot name="extra"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconLeader from "@/assets/images/projectShell/detail-icon-leader.png";
import iconYear from "@/assets/images/projectShell/detail-icon-year.png";
import iconOrg from "@/assets/images/projectShell/detail-icon-org.png";
import iconUpdate from "@/assets/images/projectShell/detail-icon-update.png";
import iconRequest from "@/assets/images/projectShell/detail-icon-request.png";
import iconEdit from "@/assets/images/projectShell/detail-icon-edit.png";
import iconBack from "@/assets/images/projectShell/detail-icon-back.png";
import StatusBadge from "./StatusBadge.vue";

export default {
  name: "ProjectDetailHeader",
  components: {
    StatusBadge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    status: {
      type: [String, Number],
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    version: {
      type: String,
      default: "",
    },
    /** [{ label, value, warn?, icon? }] */
    metaList: {
      type: Array,
      default: () => [],
    },
    showUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconMap: {
        leader: iconLeader,
        year: iconYear,
        org: iconOrg,
        update: iconUpdate,
        request: iconRequest,
      },
      icons: {
        edit: iconEdit,
        back: iconBack,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.ps-detail-head {
  box-shadow: 0 0 8px 0 rgba(115, 155, 220, 0.35);
  background: #2964d3;
  border-radius: 10px;
  padding: 19px 24px 20px;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;

  &__title {
    margin: 0 0 10px;
    color: #edf2fe;
    font-size: 23px;
    font-weight: 700;
    line-height: 1.2;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__status {
    font-weight: 600;
  }

  &__row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 28px;
    max-width: 640px;
    flex: 1;
    min-width: 280px;
  }

  &__meta-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #edf2fe;
    font-size: 16px;
    line-height: 32px;
    white-space: nowrap;

    b {
      font-weight: 400;
      color: #edf2fe;
      &.warn {
        color: #ffd4a8;
      }
    }
  }

  &__version {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.6;
    background: #fff7e6;
    color: #d46b08;
    border: 1px solid #ffd591;
    white-space: nowrap;
    vertical-align: middle;
  }

  &__meta-icon {
    width: 14px;
    height: 14px;
    object-fit: contain;
    flex-shrink: 0;

    &--year {
      width: 15px;
      height: 15px;
    }
    &--org {
      width: 15px;
      height: 13px;
    }
    &--update {
      width: 14px;
      height: 14px;
    }
    &--request {
      width: 18px;
      height: 14px;
    }
  }

  &__actions {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    flex-shrink: 0;
    padding-bottom: 4px;
  }
}

.ps-btn {
  border-radius: 4px;
  width: 113px;
  height: 34px;
  padding: 0 8px;
  font-size: 16px;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  cursor: pointer;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  box-sizing: border-box;

  img {
    display: block;
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    object-fit: contain;
  }

  span {
    line-height: 1;
    transform: translateY(1px);
  }

  &--update {
    background: #8aafff;
    color: #fff;
    &:hover {
      background: #7aa0f5;
    }
  }

  &--back {
    background: #fff;
    border-color: #a8a8a8;
    color: #4a4a4a;
    img {
      width: 20px;
      height: 14px;
    }
    &:hover {
      background: #f7f7f7;
    }
  }
}
</style>
